export function decisionCount(count:number):string {
  const form=new Intl.PluralRules('ru').select(count);
  return `${count} ${{one:'решение',few:'решения',many:'решений',other:'решения'}[form as 'one'|'few'|'many'|'other']}`;
}

